import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import CloseIcon from '../CloseIcon';

function BrightOutlookModal({ tenant, onClickParent }) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames({
        'bright-outlook__transparent-background-modal': true,
        'bright-outlook__display-none': !true,
      })}
      style={{ position: 'fixed' }}
    >
      <div className="bright-outlook__content">
        <CloseIcon
          tenant={tenant}
          onClickParent={onClickParent}
          ariaLabel={t(
            'Click here to close the bright outlook information modal'
          )}
        />
        <div className="bright-outlook__modal">
          {t(
            'Bright Outlook occupations are expected to grow rapidly in the next several years, or will have large numbers of job openings'
          )}
        </div>
      </div>
    </div>
  );
}

export default BrightOutlookModal;
